/**
 * Ensures the string ends with the given character
 * @param str The original string
 * @param endWith The character to end with
 * @param
 */
export function ensureEndsWith(str: string, endWith: string) {
	if (str == null || endWith == null) return str;

	if (str[str.length - 1] !== endWith) {
		str += endWith;
	}

	return str;
}
